module.exports = __webpack_public_path__ + "img/evaluate-common1.8817c3e2.png";